import { Box, Paper, Typography, Divider, Button } from "@mui/material";
import { LeftArowIcon } from "../../svg/LeftArowIcon";

export default function SlowNetworkCard({ onBack }: { onBack?: () => void }) {
    
  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: "8px",
        border: "1px solid #E0E0E0",
        padding: "24px",
        width: "100%",
        margin: "0 auto",
        backgroundColor: "#FFFFFF",
      }}
    >
      <Typography
        fontWeight={600}
        fontSize={"20px"}
        sx={{ color: "#013238", mb: 2 }}
      >
        Something seems wrong !!
      </Typography>

      <Divider sx={{ mb: 2 }} />

      <Typography
        variant="body1"
        sx={{ color: "#000000", fontWeight: 400, fontSize: "16px" }}
      >
        We’re experiencing a temporary issue. Please try again shortly, or contact{" "}
        <b>loansupport@ccrpartners.co</b>
      </Typography>

      <Box sx={{ mt: 3, display: "flex", justifyContent: "center" }}>
        <Button
          variant="outlined"
          onClick={() => {
            onBack?.()
          }}
          disabled={!onBack}
          className="button button-outline-primary"
        >
            <LeftArowIcon />
        <Typography
          sx={{ color: "#000000", fontWeight: 400, fontSize: "12px" }}
        >
          Go back
        </Typography>
        </Button>
      </Box>
    </Paper>
  );
}